import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import agencies from '../agencies';
import controller from './select-agency-dialog.controller';
import template from './select-agency-dialog.html';


class dialogService {
  getOptions($event, {
    audit, agencies, auditTypes, coordinators, dataTypes, refreshAudit, refreshAgencies
  }) {
    return {
      controller,
      controllerAs: 'selectAgencyDialogVM',
      locals: {
        audit,
        agencies,
        auditTypes,
        coordinators,
        dataTypes,
        refreshAudit,
        refreshAgencies
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.selectAgencyDialog', [
  agencies,
  alerts,
  constants,
  loaderService,
  ssDialogService,
])
  .service('selectAgencyDialog', dialogService)
  .name;
